import React, { useEffect, useState } from 'react';
import { HiSearch } from 'react-icons/hi';
import { FiPlusCircle } from 'react-icons/fi';
import { CiFilter } from 'react-icons/ci';
import OrganizationTable from './OrganizationTable';
import CreateOrganizationModal from '../Modal/CreateOrganizationModal';
import { shallowEqual, useSelector } from 'react-redux';
import { LoadOrganization } from '../../Redux/OrganizationSlice';
import { useDispatch } from 'react-redux';
const OrganizationListing = () => {
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedOrganizations, setSearchedOrganizations] = useState([]);
  const { organizations, isOrgAuth, user } = useSelector(
    state => ({
      organizations: state.Organization.organizations,
      user: state.User.user,
      isOrgAuth: state.Organization.isOrgAuth,
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  const onSearch = e => {
    const { value } = e.target;
    setSearchText(value);
    if (value !== '') {
      const filter = organizations.filter(_org => {
        return Object.values(_org).join('').toLocaleLowerCase().includes(value);
      });
      setSearchedOrganizations(filter);
    } else {
      setSearchedOrganizations(organizations);
    }
  };
 
  return (
    <div className="px-1 pt-1 ml-3 space-y-3 ">
      <div className="flex justify-between">
        <div className="flex space-x-3">
          <div className="relative flex items-center w-full  overflow-hidden md:w-96 border border-gray-400 rounded-lg px-3">
            <input
              className=" h-full w-full border-none text-sm outline-none bg-transparent"
              type="text"
              id="search"
              placeholder="Search"
              value={searchText}
              onChange={onSearch}
            />
            <button className="grid place-items-center h-full w-12 text-gray-300 ">
              <HiSearch className="w-6 h-6 text-gray-400" />
            </button>
          </div>
          <button className="border px-3 py-1 rounded-lg border-gray-400">
            <CiFilter className="w-6 h-6 text-black-400" />
          </button>
        </div>
        {user.role == 'admin' && (
          <button
            onClick={() => setShowModal(true)}
            className="flex justify-center items-center space-x-2 bg-red-500 px-5 py-2 text-white rounded-lg font-semibold"
          >
            <FiPlusCircle className="w-5 h-5" />
            <span>Create Organization</span>
          </button>
        )}
      </div>
      <div className="w-full">
        <OrganizationTable filtered={searchedOrganizations} />
      </div>
      <CreateOrganizationModal
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </div>
  );
};

export default OrganizationListing;
